"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/ach-batch-summary.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fach-batch-summary.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountingSummary = exports.AchTotals = exports.AchBatchSummary = exports.AchFileSummary = void 0;
const amount_1 = require("./amount");
const date_1 = require("./date");
const protobufPackage = 'com.step.common.proto';
function createBaseAchFileSummary() {
    return { totals: exports.AchTotals.fromPartial({}), batches: [] };
}
exports.AchFileSummary = {
    fromJSON(object) {
        const message = {
            totals: isSet(object.totals) ? exports.AchTotals.fromJSON(object.totals) : exports.AchTotals.fromPartial({}),
            batches: globalThis.Array.isArray(object?.batches)
                ? object.batches.map((e) => exports.AchBatchSummary.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.totals !== undefined) {
            obj.totals = exports.AchTotals.toJSON(message.totals);
        }
        if (message.batches?.length) {
            obj.batches = message.batches.map((e) => exports.AchBatchSummary.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.AchFileSummary.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchFileSummary();
        message.totals = (object.totals !== undefined && object.totals !== null)
            ? exports.AchTotals.fromPartial(object.totals)
            : exports.AchTotals.fromPartial({});
        message.batches = object.batches?.map((e) => exports.AchBatchSummary.fromPartial(e)) || [];
        return message;
    },
};
function createBaseAchBatchSummary() {
    return {
        totals: exports.AchTotals.fromPartial({}),
        batchNumber: 0,
        effectiveDate: date_1.LocalDate.fromPartial({}),
    };
}
exports.AchBatchSummary = {
    fromJSON(object) {
        const message = {
            totals: isSet(object.totals) ? exports.AchTotals.fromJSON(object.totals) : exports.AchTotals.fromPartial({}),
            batchNumber: isSet(object.batchNumber) ? globalThis.Number(object.batchNumber) : 0,
            effectiveDate: isSet(object.effectiveDate)
                ? date_1.LocalDate.fromJSON(object.effectiveDate)
                : date_1.LocalDate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.totals !== undefined) {
            obj.totals = exports.AchTotals.toJSON(message.totals);
        }
        if (message.batchNumber !== 0) {
            obj.batchNumber = Math.round(message.batchNumber);
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = date_1.LocalDate.toJSON(message.effectiveDate);
        }
        return obj;
    },
    create(base) {
        return exports.AchBatchSummary.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchBatchSummary();
        message.totals = (object.totals !== undefined && object.totals !== null)
            ? exports.AchTotals.fromPartial(object.totals)
            : exports.AchTotals.fromPartial({});
        message.batchNumber = object.batchNumber ?? 0;
        message.effectiveDate = (object.effectiveDate !== undefined && object.effectiveDate !== null)
            ? date_1.LocalDate.fromPartial(object.effectiveDate)
            : date_1.LocalDate.fromPartial({});
        return message;
    },
};
function createBaseAchTotals() {
    return { credits: exports.AccountingSummary.fromPartial({}), debits: exports.AccountingSummary.fromPartial({}) };
}
exports.AchTotals = {
    fromJSON(object) {
        const message = {
            credits: isSet(object.credits)
                ? exports.AccountingSummary.fromJSON(object.credits)
                : exports.AccountingSummary.fromPartial({}),
            debits: isSet(object.debits)
                ? exports.AccountingSummary.fromJSON(object.debits)
                : exports.AccountingSummary.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.credits !== undefined) {
            obj.credits = exports.AccountingSummary.toJSON(message.credits);
        }
        if (message.debits !== undefined) {
            obj.debits = exports.AccountingSummary.toJSON(message.debits);
        }
        return obj;
    },
    create(base) {
        return exports.AchTotals.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchTotals();
        message.credits = (object.credits !== undefined && object.credits !== null)
            ? exports.AccountingSummary.fromPartial(object.credits)
            : exports.AccountingSummary.fromPartial({});
        message.debits = (object.debits !== undefined && object.debits !== null)
            ? exports.AccountingSummary.fromPartial(object.debits)
            : exports.AccountingSummary.fromPartial({});
        return message;
    },
};
function createBaseAccountingSummary() {
    return { count: '0', amount: amount_1.Amount.fromPartial({}) };
}
exports.AccountingSummary = {
    fromJSON(object) {
        const message = {
            count: isSet(object.count) ? globalThis.String(object.count) : '0',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.count !== '0') {
            obj.count = message.count;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.AccountingSummary.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountingSummary();
        message.count = object.count ?? '0';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=ach-batch-summary.js.map